import React from "react"
import styled from "styled-components"

import { Type, Color, Wrapper } from "../../utilities"

const SectionContainer = styled.section`
  background: ${props => (props.background ? props.background : Color.white)};
  font-family: ${Type.text};
  color: ${Color.section};
  padding: 4rem 0;

  h1,
  h2,
  h3,
  h4 {
    font-family: ${Type.header};
    line-height: 150%;
    margin-bottom: 0.5rem;
  }

  h2 {
    font-size: 2rem;
  }
  h4 {
    font-size: 1.3rem;
    font-style: italic;
  }

  p {
    font-family: ${Type.text};
    color: ${Color.section};
    margin-bottom: 0;
    line-height: 200%;
  }

  ul {
    padding: 0;
    margin: 0;
    li {
      position: relative;
      padding: 0.5rem;
      padding-left: 2rem;
      list-style: none;
      ul {
        padding-left: 1rem;
      }

      &::before {
        content: "";
        position: absolute;
        left: 10px;
        top: 16px;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid ${Color.orange};
        height: 0;
        width: 0;
      }
    }
  }
`

export const Icon = styled.div`
  display: inline-block;
  background-repeat: no-repeat;
  background-size: contain;
  height: 30px;
  width: 30px;
  border-bottom: 2px dotted ${Color.grey};
  ${props =>
    props.image &&
    `
  background-image: url('${props.image}'); 
  `}
`

export const Section = ({ background, children }) => (
  <SectionContainer background={background}>
    <Wrapper>{children}</Wrapper>
  </SectionContainer>
)
